import React, { useEffect } from 'react';
import classnames from 'classnames';
import Page from '../../../page';
import { BrandsWeOffer } from '../what-we-offer/components/brands-we-offer';
import { Gallery } from '../what-we-offer/components/gallery';
import { ReadyToFindForm } from '../what-we-offer/components/ready-to-find-form';
import { AboutUs } from './components/about-us-block';
import { Banner } from './components/banner';
import { Brands } from './components/brands';
import { CategoriesBlock } from './components/categories-block';
import { PromotedProductsBlock } from './components/promoted-products-block';
import classes from './custom-home-page.scss';
export const CustomHomePage = () => {
  var _customHomePageSettin, _customHomePageSettin2, _customHomePageSettin3, _customHomePageSettin4, _customHomePageSettin5, _customHomePageSettin6, _customHomePageSettin7;
  const isInIFrame = window.self !== window.top;
  const sendScrollPositionToParent = () => {
    const scrollPosition = window.scrollY;
    window.parent.postMessage({
      type: 'scrollPosition',
      position: scrollPosition
    }, '*');
  };
  const scrollToPosition = event => {
    const {
      action,
      position
    } = event.data;
    if (action === 'scrollToPosition') {
      if (typeof position === 'number') {
        window.scrollTo({
          left: 0,
          top: position
        });
      }
    }
  };
  useEffect(() => {
    const handleScroll = () => {
      sendScrollPositionToParent();
    };
    const handleMessage = event => {
      scrollToPosition(event);
    };
    window.addEventListener('scroll', handleScroll);
    window.addEventListener('message', handleMessage);
    return () => {
      window.removeEventListener('scroll', handleScroll);
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  const storeSettings = window.swag.storeSettings;
  const customHomePageSettings = storeSettings.customHomePageSettings || {};
  const shouldShowBrands = ((_customHomePageSettin = customHomePageSettings.brandLogosBlock) === null || _customHomePageSettin === void 0 ? void 0 : _customHomePageSettin.isHidden) === false;
  const shouldShowAboutUsBlock = ((_customHomePageSettin2 = customHomePageSettings.aboutUsBlock) === null || _customHomePageSettin2 === void 0 ? void 0 : _customHomePageSettin2.isHidden) === false;
  const shouldShowCategoriesBlock = ((_customHomePageSettin3 = customHomePageSettings.categoriesBlock) === null || _customHomePageSettin3 === void 0 ? void 0 : _customHomePageSettin3.isHidden) === false;
  const shouldShowPromoProductsBlock = ((_customHomePageSettin4 = customHomePageSettings.promoProductBlock) === null || _customHomePageSettin4 === void 0 ? void 0 : _customHomePageSettin4.isHidden) === false;
  const shouldShowBrandsWeOfferBlock = ((_customHomePageSettin5 = customHomePageSettings.brandsWeOfferBlock) === null || _customHomePageSettin5 === void 0 ? void 0 : _customHomePageSettin5.isHidden) === false;
  const shouldShowImagesRowBlock = ((_customHomePageSettin6 = customHomePageSettings.imagesRowBlock) === null || _customHomePageSettin6 === void 0 ? void 0 : _customHomePageSettin6.isHidden) === false;
  const shouldShowContactFormBlock = !customHomePageSettings.contactFormBlock || ((_customHomePageSettin7 = customHomePageSettings.contactFormBlock) === null || _customHomePageSettin7 === void 0 ? void 0 : _customHomePageSettin7.isHidden) === false;
  const heroBlock = customHomePageSettings.heroBlock || {};
  const brandLogosBlock = customHomePageSettings.brandLogosBlock || {};
  const aboutUsBlock = customHomePageSettings.aboutUsBlock || {};
  const categoriesBlock = customHomePageSettings.categoriesBlock || {};
  const promoProductsBlock = customHomePageSettings.promoProductBlock || {};
  const imagesRawBlock = customHomePageSettings.imagesRowBlock || {};
  const contactFormBlock = customHomePageSettings.contactFormBlock || {};
  return /*#__PURE__*/React.createElement(Page, {
    headerIsTransparent: true
  }, /*#__PURE__*/React.createElement("div", {
    className: classnames(classes.root, {
      [classes.rootInIFrame]: isInIFrame
    })
  }, /*#__PURE__*/React.createElement(Banner, heroBlock), shouldShowBrands && /*#__PURE__*/React.createElement(Brands, brandLogosBlock), shouldShowAboutUsBlock && /*#__PURE__*/React.createElement(AboutUs, aboutUsBlock), shouldShowCategoriesBlock && /*#__PURE__*/React.createElement(CategoriesBlock, {
    headingText: categoriesBlock.headingText
  }), shouldShowPromoProductsBlock && /*#__PURE__*/React.createElement(PromotedProductsBlock, {
    headingText: promoProductsBlock.headingText
  }), shouldShowBrandsWeOfferBlock && /*#__PURE__*/React.createElement(BrandsWeOffer, null), shouldShowImagesRowBlock && /*#__PURE__*/React.createElement(Gallery, {
    images: imagesRawBlock.imgUrls || [],
    showPlaceholders: true
  }), shouldShowContactFormBlock && /*#__PURE__*/React.createElement("div", {
    className: classes.formContainer
  }, /*#__PURE__*/React.createElement(ReadyToFindForm, {
    headingText: contactFormBlock.headingText || 'Let us know how we can help',
    bodyText: contactFormBlock.bodyText,
    shouldShowBodyTextPlaceholder: true
  })), /*#__PURE__*/React.createElement("div", {
    className: classes.cover
  })));
};